var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row cemetery-files-content" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("UploadMultipleFile", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "",
              expression: "''",
            },
          ],
          attrs: {
            disabled: _vm.readonlyForm,
            acceptTypes: _vm.acceptTypes,
            maxFiles: _vm.maxFiles,
            name: "cemetery-files",
            keyFile: "file",
            pathProperty: "url",
            filenameProperty: "filename",
            extraNewProperties: _vm.newFileProperties,
            "data-vv-scope": _vm.vScope,
          },
          model: {
            value: _vm.form,
            callback: function ($$v) {
              _vm.form = $$v
            },
            expression: "form",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }